import AbstractScene from './AbstractScene.js';
import { Colors } from '../consts/Colors.js';
import Popup from '../prefabs/Popup.js';
import PopupFin from '../prefabs/PopupFin.js';
import { TextContents, CartesInfos, ZonesInfos } from '../consts/DataGame3.js';
import Deck3 from '../prefabs/game3/Deck3.js';
import Zone3 from '../prefabs/game3/Zone3.js';

export default class Game3 extends AbstractScene {
    constructor() {
        super({
            key: "Game3"
        })
    }
    init(data) {
        this._init(data);
        this.zonesInfos = ZonesInfos;
    }

    preload() {
        this._preload();
        this.cameras.main.setBackgroundColor(Colors.Text.Beige);
    }

    create() {
        console.log('Create :',this.scene.key);
        CartesInfos.sort(() => Math.random() - 0.5);

        this.transitionRect = this.add.rectangle(0, 0, 1920, this.height, Colors.Elmt.DarkBlue, 1).setOrigin(0, 0).setDepth(12)

        // Ajout elements du fond
        let background = this.add.sprite(720, 540, "backGame3")

        // Ajout element interactifs
        this.addDropZone()

        this.deck3 = new Deck3(this, 1700, 540);

        this.transitionIn()
    }

    launchPopup() {
        this.popup = new Popup(this, TextContents.popup.text, 756, false);
        this.popup.introBtn.setClickFunction(() => {
            this.popup.destroy();
            let delay = 0;
                console.log(this.zones)
            let indices =[0,1,2,3,0,1,2,3]
            indices.forEach((indice, index) => {
                this.zones.getChildren()[indice].bounceAnimation(delay)
                delay += 200
            });
            this.zones.getChildren().forEach(zone => {
                zone.setActive();
                
            });
        })
    }

    launchEndPopup() {
        this.popup = new PopupFin(this, TextContents.popupFin.text, 756);
        this.popup.introBtn.setClickFunction(() => {
            this.transitionOut()

        })
    }


    addDropZone() {
        this.zones = this.add.group();
        this.zonesInfos.forEach( zoneInfo => {
            let newZone = new Zone3(this, zoneInfo)
            this.zones.add(newZone)
        })
    }
    resetDropZones(){
        this.zones.getChildren().forEach(zone => {
            zone.reset()
        });
    }

    transitionIn() {
        // this.transitionRect.setAngle(180);
        let X = 1480
        this.tweens.add({
            targets: this.transitionRect,
            duration: 500,
            ease: 'Linear',
            width: this.width-X,
            x: X,
            onComplete: () => {
                this.transitionRect.setDepth(-1)
                this.launchPopup();
            }
        })

    }

    transitionOut() {
        this.tweens.add({
            targets: this.deck1,
            duration: 500,
            alpha: 0,
            onComplete: () => {
                this.transitionRect.setDepth(12)
                this.tweens.add({
                    targets: this.transitionRect,
                    x: 0,
                    duration: 500,
                    onUpdate: () => {
                        this.transitionRect.width = 1920 - this.transitionRect.x;
                        // this.transitionRect.x = 1904 - this.transitionRect.width
                    },
                    onComplete: () => {
                        this.nextScene()
                    }
                })
            }
        })
    }
}